import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {ROUTE_NAMES} from "../../../core/consts";
import {DynamicPagesLinkParams} from "./dynamic-pages.link-params";

export class DynamicPagesLinkModel extends BaseLinkModel  {
  constructor(pageName: String) {
    super(ROUTE_NAMES.pages, new DynamicPagesLinkParams(pageName));
  }
}
